import {Component, OnInit} from '@angular/core';
import {AttendeeService, PointExplanation} from "../../../services/attendee.service";
import {Room, RoomService} from "../../../services/room.service";
import {UserService} from "../../../services/user.service";
import { ActivatedRoute, RouterLink } from "@angular/router";
import {firstValueFrom} from "rxjs";
import { FooterComponent } from '../../../components/footer/footer.component';
import { PointsBreakdownComponent } from '../../../components/points-breakdown/points-breakdown.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-review-room',
    templateUrl: './review-room.component.html',
    styleUrls: ['./review-room.component.scss'],
    standalone: true,
    imports: [RouterLink, NgIf, PointsBreakdownComponent, FooterComponent]
})
export class ReviewRoomComponent implements OnInit {

  room?: Room ;

  constructor(
    private $user: UserService,
    private $rooms: RoomService,
    private route: ActivatedRoute
  ) {
  }

  async ngOnInit() {

    const roomId = this.route.snapshot.params['roomId'];

    this.room = await firstValueFrom(this.$rooms.getRoom(roomId)) ;

  }

}
